var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isShow)?_c('el-button',{attrs:{"type":"warning","size":"mini","icon":"el-icon-delete","disabled":_vm.disabled}},[_vm._v(_vm._s(_vm.label))]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }